<template>
  <section id="services" class="section services">
    <div class="heading">
      <h2>Services</h2>
      <p data-aos="fade-up">Know Me More</p>
    </div>
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-lg-6 mb-5" data-aos="zoom-in">
          <div class="card">
            <div class="card-body">
              <i class="fa-solid fa-globe"></i>
              <div class="services-info">
                <h3>Website Development</h3>
                <p>Building, creating, and maintaining of websites. It includes aspects such as web design, web publishing, web programming, and database management.</p>

              </div>
               </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 mb-5" data-aos="zoom-in">
          <div class="card">
            <div class="card-body">
              <i class="fa-solid fa-mobile"></i>
              <div class="services-info">
                <h3>Mobile Application Development</h3>
                <p>
                  Building, creating, and maintaining of Mobile Application. It includes aspects such as Application design, Application programming, and database management.
                </p>

              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 mb-5" data-aos="zoom-in">
          <div class="card">
            <div class="card-body">
              <i class="fa-solid fa-chart-area"></i>
              <div class="services-info">
                <h3>System Analysis</h3>
                <p>
                  Process of collecting and interpreting facts, identifying the problems, and decomposition of a system into its components and create systems.
                </p>

              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 mb-5" data-aos="zoom-in">
          <div class="card">
            <div class="card-body">
              <i class="fa-solid fa-bullhorn"></i>
              <div class="services-info">
                <h3>SEO Marketing</h3>
                <p>
                  Increase SEO in digital or online marketing Increase visits to your website by modifying pages for search engine optimization.
                </p>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "VueServices",
  mounted() {



  }
}
</script>

<style scoped>
.services{
  padding: 50px 0;
}


.services .card{
  padding: 5px;
  position: relative;
  background-color: transparent;
  display: flex;
  width: 100%;
  overflow: hidden;
  border: none;
  box-shadow: 0 0 40px rgba(0,0,0,0.4);
  border-radius: 15px;
}
.services .card:before{
  content: "";
  position: absolute;
  width: 25%;
  height: 25%;
  bottom: 0;
  left: 0;
  background-color: rgba(71,83,253,0.2);
  z-index: 1;
  transition: all linear 0.3s 0.01s;
}
.services .card:after{
  content: "";
  position: absolute;
  width: 25%;
  height: 25%;
  top: 0;
  right: 0;
  background-color: rgba(71,83,253,0.2);
  z-index: 1;
  transition: all linear 0.3s 0.01s;
}
.services .card:hover:before,
.services .card:hover:after,
.services .card:hover > .card-body i
{
  background-color: var(--primary-color);
  transition: all linear 0.3s 0.01s;
}
.services .card .card-body{
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: center;
  align-items: flex-start;
  background-color: var(--bg-body);
  z-index: 2;
  border-radius: 10px;
}
.card-body i{
  font-size: 36px;
  background-color: rgba(71,83,253,0.2);
  padding: 10px;
  color: var(--font-color);
  border-radius: 10px;
  transition: all linear 0.3s 0.01s;
}
.services-info{
  display: flex;
  flex-direction: column;
  gap: 10px;
}


</style>